import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from '@michelin/central-provider';
import { Container, LoadingBounce } from '@michelin/acid-components';
import { Paper } from '@material-ui/core';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import { PageTitle } from 'Utils/CanvasPageTitle';
import LastModified from 'components/ChangeLog/LastModified';
import { ChangeLogEntities } from 'Types';
import { TechServiceAreaLocationsListTable } from './ListTable';

export function TechnicianServiceAreaList() {
  const { stNumber, btNumber } = useParams<{
    stNumber: string;
    btNumber: string;
  }>();
  const { t } = useTranslation();
  const history = useHistory();
  const permissions = usePermissionsSPP();

  if (permissions.isLoading) {
    return <LoadingBounce style={{ height: '70vh' }} />;
  }
  if (!permissions.allowsAction('technician_service_area.read')) {
    history.push(`/${btNumber}`);
  }
  return (
    <>
      <PageTitle
        title={t('Technician Service Area')}
        rightItems={
          <LastModified entity={ChangeLogEntities.locationInformation} />
        }
      />
      <Container>
        <Paper>
          <TechServiceAreaLocationsListTable stNumber={stNumber} />
        </Paper>
      </Container>
    </>
  );
}
